export default __webpack_public_path__ + "static/media/IBMChevronBreadcrumb.0858d1a9.svg";